import styled from "styled-components";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { Container } from "../../theme/styles";
import { useLocation } from "react-router-dom";
import { MainBanner } from "../../components/MainBanner";
import bannerSrc from "../../assets/images/banner-blog.jpeg";
import graf01 from "../../assets/images/graf01.png"
import graf02 from "../../assets/images/graf02.png"
import { useParams } from "react-router-dom";
import { BlogPost, useBlogPost } from "../../hooks/useBlogPost";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";
import BlogComponents from "./components/BlogComponents";


interface FlexProps {
  align?: string;
  justify?: string;
  direction? : string;
}

function Blogpost() {
  usePageTrack();

  const params = useParams();
  const location: any = useLocation();
  const id: number = Number(params.id) || 0
  const postData: BlogPost = useBlogPost(id, location?.state?.post);

  function formatDate(date: string) {
    if (!date) return '';

    const d = date.split('-'); // yyyy-mm-dd
    return `${d[2]}/${d[1]}/${d[0]}`
  }

  function transformDetailText(date: string, author: string) {
    let transformText = '';

    if(formatDate(date)) {
      transformText += formatDate(date);

      transformText += author? ' • ' : '';
    }

    if(author) {
      transformText += author;
    }
    return transformText;
  }

  const transformedDetailText = transformDetailText(postData.date, postData.author);

  return (
    <>
      <base target="_blank"/>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <GraphDiv align="baseline" justify="flex-end">
        <Graph src={graf01} width="calc(15%)" />
      </GraphDiv>
      <HeadContainer>
        <Title>{postData.title}</Title>
        {postData.description? (<Text fontSize={25}>{postData.description}</Text>) : ('')}
        {transformedDetailText? (
          <DetailText fontSize={25}>{transformedDetailText}</DetailText>
        ) : ('')}

        <Divider></Divider>

      </HeadContainer>
      <Content>
        { postData.components.map((component, index) => <BlogComponents key={index} block={component} />) }
      </Content>
      <GraphDiv align="flex-end" justify="flex-start">
        <Graph src={graf02} width="calc(4%)" />
      </GraphDiv>
      <Footer />
    </>
  );
}

export default Blogpost;

const HeadContainer = styled(Container)`
  align-items: flex-start;
  text-align: center;
  padding: 0px 110px 0px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0px 18px 0px;
  }
`;

const Content = styled(Container)`
  padding: 0px 32px 64px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  font-size: 20px;
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-align: justify;
  text-justify: inter-word;

  * {
    text-indent: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-align: inherit;
    text-justify: inherit;
    font-size: inherit;
  }
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
    padding: 0 26px;
    // text-align: center;
    margin: auto;
    font-weight: 400;
  }
`;

const Title = styled.h2`
  padding: 0px 0 18px;
  font-size: 45px;
  color: ${({ theme }) => theme.colors.blue.dark};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 15px 0 18px;
    text-align: center;
    margin: auto;
    font-size: 40px;
  }
`;


const Text = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.black.dark};
  font-size: ${({ fontSize }: { fontSize: number }) => `${fontSize}px`};
  padding: 0 18px 18px;
  font-family: Raleway;
  font-style: italic;
  font-weight: 500;
  line-height: ${({ fontSize }: { fontSize: number }) => `${fontSize + 10}px`};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: ${({ fontSize }: { fontSize: number }) => fontSize <= 20 ? '16px': '22px'};
    line-height: ${({ fontSize }: { fontSize: number }) => fontSize<= 20 ? '26px': '32px'};
    padding: 0px 2px 18px;
    text-align: center;
    margin: auto;
  }
`;

const DetailText = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.blue.dark};
  // background: ${({ theme }) => theme.colors.pink.light};
  font-size: ${({ fontSize }: { fontSize: number }) => `${fontSize}px`};
  padding: 0 18px 18px;
  font-family: Raleway;
  line-height: ${({ fontSize }: { fontSize: number }) => `${fontSize + 10}px`};
  font-style: italic;
  font-weight: 600;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: ${({ fontSize }: { fontSize: number }) => fontSize <= 20 ? '16px': '22px'};
    line-height: ${({ fontSize }: { fontSize: number }) => fontSize<= 20 ? '26px': '32px'};
    padding: 0 0 18px;
    margin: 10px;
    text-align: center;
    margin: auto;
  }
`;

const Divider = styled.hr`
  border: none;
  background-color: ${({ theme }) => theme.colors.blue.darker};
  height: 5px;
  width: 10%;
  margin: 0 auto 32px;
`;

const Graph = styled.img`
  display: block;
  width: ${({ width }: { width?: string }) => width? width: '17%'};
  height: auto;
  position: absolute;
  z-index: -1;
`;

const GraphDiv = styled.div<FlexProps>`
  display: flex;
  width: 100%;
  height: auto;
  position: absolute;
  align-items: ${({ align }) => align ? align: 'center'};
  justify-content: ${({ justify }) => justify ? justify: 'flex-start'};
  flex-direction: ${({ direction }) => direction ? direction: 'row'};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    display: none;
  }
`;